import { render, staticRenderFns } from "./project-documents.vue?vue&type=template&id=43f63b26"
import script from "./project-documents.vue?vue&type=script&lang=js"
export * from "./project-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports